"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import WaveDropActions from "@/components/waves/drops/WaveDropActions";
import MemeWinnerHeader from "./MemeWinnerHeader";
import MemeWinnerDescription from "./MemeWinnerDescription";
import MemeWinnerArtistInfo from "./MemeWinnerArtistInfo";
import MemeDropTraits from "./MemeDropTraits";
import DropMobileMenuHandler from "@/components/waves/drops/DropMobileMenuHandler";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { useDropContext } from "@/components/waves/drops/DropContext";
interface MemeWinnerDropProps {
  readonly drop: ExtendedDrop;
  readonly showReplyAndQuote: boolean;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
}
export default function MemeWinnerDrop(t0) {
  const $ = _c(52);
  const {
    drop,
    showReplyAndQuote,
    onReply,
    onQuote
  } = t0;
  const isMobile = useIsMobileDevice();
  const {
    location
  } = useDropContext();
  let t1;
  if ($[0] !== drop.metadata) {
    t1 = drop.metadata?.find(_temp)?.data_value ?? "Artwork Title";
    $[0] = drop.metadata;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  let t2;
  if ($[2] !== drop.metadata) {
    t2 = drop.metadata?.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
    $[2] = drop.metadata;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const description = t2;
  let t3;
  if ($[4] !== drop.parts) {
    t3 = drop.parts.at(0)?.media?.at(0);
    $[4] = drop.parts;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const artworkMedia = t3;
  let t4;
  if ($[6] !== drop || $[7] !== onReply) {
    t4 = () => {
      onReply({
        drop,
        partId: drop.parts[0].part_id
      });
    };
    $[6] = drop;
    $[7] = onReply;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleOnReply = t4;
  let t5;
  if ($[9] !== drop || $[10] !== onQuote) {
    t5 = () => {
      onQuote({
        drop,
        partId: drop.parts[0].part_id
      });
    };
    $[9] = drop;
    $[10] = onQuote;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleOnQuote = t5;
  const t6 = `tw-w-full ${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""} tw-relative tw-group`;
  const t7 = `tw-rounded-xl tw-border tw-border-solid tw-border-transparent tw-border-l tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden ${location === DropLocation.WAVE ? "tw-bg-iron-900/80" : "tw-bg-iron-950"} ${"tw-shadow-[inset_1px_0_0_#fbbf24,inset_0_1px_0_rgba(251,191,36,0.2),inset_-1px_0_0_rgba(251,191,36,0.2),inset_0_-1px_0_rgba(251,191,36,0.2)]"}`;
  let t8;
  if ($[12] !== drop) {
    t8 = <div className="tw-flex tw-flex-col tw-gap-4"><MemeWinnerArtistInfo drop={drop} /></div>;
    $[12] = drop;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== title) {
    t9 = <MemeWinnerHeader title={title} />;
    $[14] = title;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== description) {
    t10 = <MemeWinnerDescription description={description} />;
    $[16] = description;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div className="tw-flex tw-flex-col tw-mt-2 sm:tw-mt-1.5 sm:tw-ml-[3.25rem]">{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t8) {
    t12 = <div className="tw-p-4">{t8}{t11}</div>;
    $[21] = t11;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== artworkMedia || $[25] !== location) {
    t13 = artworkMedia && <div className={`tw-flex tw-justify-center tw-mx-[1px] tw-h-96 ${location === DropLocation.WAVE ? "tw-bg-iron-800/30" : ""}`}><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
    $[24] = artworkMedia;
    $[25] = location;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== drop) {
    t14 = <MemeDropTraits drop={drop} />;
    $[27] = drop;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t14) {
    t15 = <>{t12}{t13}{t14}</>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== drop || $[34] !== handleOnQuote || $[35] !== handleOnReply || $[36] !== showReplyAndQuote || $[37] !== t15) {
    t16 = <DropMobileMenuHandler drop={drop} showReplyAndQuote={showReplyAndQuote} onReply={handleOnReply} onQuote={handleOnQuote}>{t15}</DropMobileMenuHandler>;
    $[33] = drop;
    $[34] = handleOnQuote;
    $[35] = handleOnReply;
    $[36] = showReplyAndQuote;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== drop || $[40] !== handleOnQuote || $[41] !== handleOnReply || $[42] !== isMobile || $[43] !== showReplyAndQuote) {
    t17 = !isMobile && showReplyAndQuote && <div className="tw-absolute tw-right-4 tw-top-2"><WaveDropActions drop={drop} activePartIndex={0} onReply={handleOnReply} onQuote={handleOnQuote} /></div>;
    $[39] = drop;
    $[40] = handleOnQuote;
    $[41] = handleOnReply;
    $[42] = isMobile;
    $[43] = showReplyAndQuote;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t16 || $[46] !== t17 || $[47] !== t7) {
    t18 = <div className={t7}>{t16}{t17}</div>;
    $[45] = t16;
    $[46] = t17;
    $[47] = t7;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t18 || $[50] !== t6) {
    t19 = <div className="tw-w-full"><div className={t6}>{t18}</div></div>;
    $[49] = t18;
    $[50] = t6;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  return t19;
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp(m) {
  return m.data_key === "title";
}